var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "_127U0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14623",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2287",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14622",
    transform: "translate(2 2)",
    fill: "#003574"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2274",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 10.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2275",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 5)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2276",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(10.75 16.5)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5687",
    fill: "none",
    d: "M-6-6h40v40H-6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots2);
export default __webpack_public_path__ + "static/media/dots2.09e97aa693c3e18dcca4f629dfe755e1.svg";
export { ForwardRef as ReactComponent };